import I18n from 'i18n-js';

const languages = require('./languages.json').languages;

let languageCode = 'en';
// TODO match if chinese language
// if (locales.length && locales[0].languageCode === 'zh') {
//     languageCode = 'zh';
// }
languageCode = languageCode.substring(0, 2);
I18n.defaultLocale = languageCode;
I18n.locale = languageCode;

// Enable fallbacks if you want `en-US` and `en-GB` to fallback to `en`
I18n.fallbacks = true;

// English language is the main language for fall back:
I18n.translations = {
    en: languages['en-US']
};

// All other translations for the app goes to the respective language file:
switch (languageCode) {
    case 'zh':
        I18n.translations.zh = languages['zh-CN'];
        break;
}
